@if (isCompletion) {
  <app-completion-message heading="You're all set" message="All steps are complete. You may close this page now." />
} @else {
  <div class="status-page">
    <img [src]="imgUrl" alt="Money box" />
    <div class="sub-head">{{ message[errorCode] }}</div>
  </div>
}
